/** Locality selector — "All localities" + one option per locality (from the API). */
import { useId } from "react";
import { useTranslation } from "react-i18next";

import { useLocalities } from "@/features/localities/queries";
import { localityLabel } from "@/lib/localities";

interface LocalitySelectProps {
  value: string | null;
  onChange: (locality: string | null) => void;
  label?: string;
}

export function LocalitySelect({ value, onChange, label }: LocalitySelectProps) {
  const { t, i18n } = useTranslation();
  const id = useId();
  const { data, isLoading } = useLocalities();
  const names = (data ?? []).map((l) => l.name);
  return (
    <div className="inline-flex items-center gap-2 text-sm">
      <label htmlFor={id} className="text-fg-muted">
        {label ?? t("controls.locality")}
      </label>
      <select
        id={id}
        value={value ?? ""}
        disabled={isLoading}
        onChange={(e) => onChange(e.target.value || null)}
        className="max-w-[12rem] rounded-md border border-border bg-bg px-2 py-1 text-sm outline-none focus:border-brand focus:ring-1 focus:ring-brand disabled:opacity-60"
      >
        <option value="">{t("controls.allLocalities")}</option>
        {names.map((name) => (
          <option key={name} value={name}>
            {localityLabel(name, i18n.language)}
          </option>
        ))}
      </select>
    </div>
  );
}
